/* @flow */

export default class ToggleEnableCompanyBankAccountRequest {
  companyId: number;
  bankAccountId: number;

  constructor(companyId: number, bankAccountId: number) {
    this.companyId = companyId;
    this.bankAccountId = bankAccountId;
  }
}
